import { EMPTY_VALUE, PARAM_TYPE_BOOLEAN } from "constant/application";
import { PropFormikField } from "constant/prop-types";
import PropTypes from "prop-types";
import React from "react";
import Select from "react-select";
import { getBooleanOptions, getOpt, STYLES } from "util/select";

// Boolean field is rendered as Select with True/False options
const OPTIONS = getBooleanOptions();

class BooleanField extends React.PureComponent {
  static get propTypes() {
    return {
      field: PropFormikField.isRequired,
      handleChange: PropTypes.func.isRequired,
      readOnly: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      readOnly: false,
    };
  }

  constructor() {
    super();

    this._onChange = this._onChange.bind(this);
  }

  _onChange(opt) {
    const value = opt === null ? opt : opt.value;

    this.props.handleChange(value);
  }

  render() {
    const { field, readOnly } = this.props;

    const { name, value } = field;
    // Single select can be null or object.
    const selected =
      value === null || value === undefined
        ? EMPTY_VALUE[PARAM_TYPE_BOOLEAN]
        : getOpt(OPTIONS, value);

    return (
      <Select
        isDisabled={readOnly}
        isMulti={false}
        name={name}
        onChange={this._onChange}
        options={OPTIONS}
        styles={STYLES}
        value={selected}
        isClearable
      />
    );
  }
}

export { BooleanField };
